<template>
  <div :class="icoMainDiv">
    <div class="mt-0">
      <b-card no-body class="mt-2 v3_box_teal">
        <b-card-body class="v3_box_teal_body">
          <div class="box-body-wrapper flex-column p-3">
            <b class="v3_color_teal v2_font_size_22 text-center" v-if="!user"> Find Your Perfect Candidates<br /></b>
            <b class="v3_color_teal mt-2 v2_font_size_22 text-center" v-if="(showJobTermText && !this.jobInfoText && !this.showJobLandingContent) || (this.isShowStep==6)"> Find Even More Perfect Candidates</b>
            <b class="v3_color_teal mt-2 text-center v2_font_size_22" v-if="this.isShowStep==1 && this.jobInfoText && !this.showJobLandingContent"> Job Opportunity Information</b>
            <!-- <b class="v3_color_teal mt-2 text-center v2_font_size_22" v-if="this.isShowStep==1 && this.showJobLandingContent"> <span v-html="this.landingContent? this.landingContent[0].content_json.header : ''"></span></b> -->
            <b class="v3_color_teal mt-2 text-center v2_font_size_22" v-if="isShowStep === 1 && showJobLandingContent"><span v-html="landingContent && landingContent.length > 0 && landingContent[0].content_json ? landingContent[0].content_json.header : ''"></span></b>
            <b class="v3_color_teal mt-2 text-center v2_font_size_22" v-if="this.isShowStep==3"> Review Your Job Opportunity</b>
            <b class="v3_color_teal v2_font_size_22 text-center" v-if="this.isShowStep == 4"> Pay & Connect<br/></b>
            <span class="v3_color_teal mt-2 text-center" v-if="!user">Specify the criteria of your open job and immediately see how many candidates are interested in it.</span>
            <b-row v-if="user">
              <b-col cols="12" class="d-flex justify-content-center align-items-center">
                <template v-if="this.isShowStep==1">
                    <div class="text-center mt-20 p-2" 
                      :class="{ 
                        'mb-2':this.jobInfoText 
                        }">
                      <template v-if="this.jobInfoText"> 
                        <span class="v3_color_teal text-center">Showcase your position – tell candidates what they need to know about your opportunity.<br/></span> 
                       </template>
                      <template v-else-if="showJobTermText && !this.showJobLandingContent">
                        <span class="v3_color_teal mt-2 text-center">Refine the terms of your job opportunity using additional criteria to better match to the candidates you want.  <br /></span>
                        <span class="v3_color_teal text-center">Once you are satisfied, click “Connect Your Opportunity”.</span>
                      </template>
                      <template v-else> 
                        <span class="v3_color_teal text-center" v-if="!this.showJobLandingContent">Select from the “Job Criteria” menu if you want to refine or add to the specific terms of your job opportunity.</span>  
                      </template>
                    </div>
                </template>
                <template v-if="this.isShowStep==3">
                    <div class="text-center p-2 mb-2">
                        <span class="v3_color_teal text-center">Review your information for accuracy to ensure precise matching of ideal candidates.</span>
                    </div>
                </template>
                <template v-if="this.isShowStep == 5">
                  <div class="text-center mt-2">
                      <p class="v3_color_teal v2_font_size_22 font_weight_semibold">That’s it! </p>
                      <span class="v3_color_teal text-center">We’ve connected your job opportunity to the physician candidates that have expressed an interest in it. </span>
                  </div>
                </template>
                <template v-if="this.isShowStep == 4">
                  <div class="text-center mt-2 mb-3">
                      <span class="v3_color_teal text-center">You’re set to go! Complete the payment fields below and we’ll immediately connect your opportunity to all interested candidates.</span>
                  </div>
                </template>
                <template v-if="this.isShowStep == 6">
                  <div class="text-center mt-2 mb-3">
                    <span class="v3_color_teal mt-2 text-center">Refine the terms of your job opportunity using additional criteria to better match to the candidates you want.  <br /></span>
                    <span class="v3_color_teal text-center">Once you are satisfied, click “Connect Your Opportunity”.</span>
                  </div>
                </template>
              </b-col>
              <template v-if="this.isShowStep == 2">
                <!-- <b-col cols="12" class="d-flex justify-content-center align-items-center">
                  <b class="v3_color_teal mt-4">Register Your Job Opportunity</b>
                </b-col> -->
              </template>
          </b-row>

            <!-- <b-row class="w-100 mt-3">
              <b-col sm="12" md="4" lg="3">
                <div class="text-center">
                    <b class="v3_color_teal">Step 1. Select Job Criteria</b>
                </div>
              </b-col>
              <b-col sm="12" md="8" lg="6">
                <div class="text-center">
                    <b class="v3_color_teal">Step 2. Define Job Criteria</b>
                </div>
              </b-col>
              <b-col sm="12" md="12" lg="3">
                <div class="text-center">
                    <b class="v3_color_teal">Step 3. Evaluate Results</b>
                </div>
              </b-col>
          </b-row> -->
         
            <b-row class="w-100">
              <b-col sm="12" md="4" lg="3" class="mb-5" ref="step1" id="step1">

                <div class="text-center mt-2 mb-1" v-if="!this.jobInfoText || this.isShowStep == 6">
                    <b class="v3_color_teal">Step 1. Select Job Criteria</b>
                </div>
                <recruiter-ico-criteria
                  :loading="!criteriaItems.length"
                  :criteria-items="criteriaItems"
                  @changeCriteriaBtn="handlechangeCriteriaBtn"
                  :isChangeJobCriteriaEnable="this.isChangeJobCriteriaEnable"
                >
                  <template slot-scope="{ items, getLabel }">
                    <div
                      class="d-flex flex-column justify-content-stretch mt-3"
                    >
                      <template v-for="(item, index) in items" >

                        <div
                          :id="`criteria-btn-${item.id}`"
                          :key="`criteria-btn-${item.id}`"
                          :set="(disabled = !isSpecialtySubspecialtySpecified &&
                          item.type !== JOB_QUESTION_TYPES.SPECIALTY)"
                          tabindex="0"
                          class="d-flex flex-column justify-content-stretch"
                          v-if="item.type !== JOB_QUESTION_TYPES.JOB_INFORMATION"
                        >
                        <b-button
                            variant="v3_teal_outline text-break"
                            :class="[
                              'mb-2',
                              'position-relative',
                              {
                                active: selectedJobQuestionId === item.id,
                              },
                            ]"
                            @click="onChangeCriteria(item)" 
                            :disabled="isLabelDisable(index)"  
                            
                            
                          >
                          <!-- :disabled="getLabel(item) == 'Location' ? LocationDisabled : (getLabel(item) == 'Practice Type' ? practiceTypeFlag : (getLabel(item) == 'Maximum Total Compensation') ? maxCompFlag : getLabel(item) == 'Specialty/Subspecialty' ? isSpecialtyDisabled : (getLabel(item) == 'Gender') ? isGenderDisabled :  (getLabel(item) == 'Race / Ethnicity') ? isEthnicityDisabled : (getLabel(item) == 'Board Certification') ? isBoardDisabled : (getLabel(item) == 'Visa Status') ? isVisaDisabled : true )" -->
                          
                          <span>
                            <i class="mdi mdi-lock" v-if="displayLock(index)" />
                             <!-- v-if="getLabel(item) == 'Location' ? LocationLocked : (getLabel(item) == 'Practice Type' ? practiceTypeFlag : (getLabel(item) == 'Maximum Total Compensation') ? maxCompFlag : getLabel(item) == 'Specialty/Subspecialty' ? isSpecialtyLocked : (getLabel(item) == 'Gender') ? isGenderDisabled :  (getLabel(item) == 'Race / Ethnicity') ? isEthnicityDisabled : (getLabel(item) == 'Board Certification') ? isBoardDisabled : (getLabel(item) == 'Visa Status') ? isVisaDisabled : true)" -->
                            {{ getLabel(item) }}
                          </span>
                          </b-button>
                        </div>
                        <template v-if="!user">
                        <b-tooltip
                          v-if=" item.type !== JOB_QUESTION_TYPES.GENDER && item.type !== JOB_QUESTION_TYPES.VISA_STATUS && item.type !== JOB_QUESTION_TYPES.ETHNICITY && item.type !== JOB_QUESTION_TYPES.BOARD_CERTIFICATION"
                          :key="`criteria-tooltip-${item.id}`"
                          :target="`criteria-btn-${item.id}`"
                          triggers="hover"
                        >
                            Specialty, Location, Practice Type, and Compensation of your opportunity are required to see the yield of matching candidates.
                        </b-tooltip>
                        <b-tooltip
                          v-else
                          :key="`criteria-tooltip-${item.id}`"
                          :target="`criteria-btn-${item.id}`"
                          triggers="hover"
                        >
                            These additional Job Criteria filters are available after you connect this opportunity.
                        </b-tooltip>
                      </template>
                      </template>
                    </div>
                    <!-- <span ref="step2" id="step2"></span> -->
                  </template>
              </recruiter-ico-criteria>




                <!-- <recruiter-ico-criteria
                  :loading="!criteriaItems.length"
                  :criteria-items="criteriaItems"
                  @changeCriteriaBtn="handlechangeCriteriaBtn"
                  :isChangeJobCriteriaEnable="this.isChangeJobCriteriaEnable"
                >
                  <template slot-scope="{ items, getLabel }">
                    <div
                      class="d-flex flex-column justify-content-stretch mt-3"
                    >
                      <template v-for="item in items">
                        <div
                          :id="`criteria-btn-${item.id}`"
                          :key="`criteria-btn-${item.id}`"
                          :set="(disabled = !isSpecialtySubspecialtySpecified &&
                          item.type !== JOB_QUESTION_TYPES.SPECIALTY)"
                          tabindex="0"
                          class="d-flex flex-column justify-content-stretch"
                          v-if=" item.type !== JOB_QUESTION_TYPES.GENDER && item.type !== JOB_QUESTION_TYPES.VISA_STATUS && item.type !== JOB_QUESTION_TYPES.ETHNICITY && item.type !== JOB_QUESTION_TYPES.BOARD_CERTIFICATION && item.type !== JOB_QUESTION_TYPES.JOB_INFORMATION"
                        >
                          <b-button
                            variant="v3_teal_outline text-break"
                            :class="[
                              'mb-2',
                              'position-relative',
                              {
                                active: selectedJobQuestionId === item.id,
                              },
                            ]"
                            :disabled_1="disabled"
                            :disabled="getLabel(item) == 'Location' ? LocationDisabled : (getLabel(item) == 'Practice Type' ? practiceTypeFlag : (getLabel(item) == 'Maximum Total Compensation') ? maxCompFlag : (getLabel(item) == 'Specialty/Subspecialty' ? isSpecialtyDisabled : true) )"
                            @click="onChangeCriteria(item)"
                          >
                          <span>
                            <i class="mdi mdi-lock" 
                            v-if="showLockIconOnQuestion(item)" />
                            {{ getLabel(item) }}
                          </span>

                          </b-button>
                        </div>
                        <div
                          :id="`criteria-btn-${item.id}`"
                          :key="`criteria-btn-${item.id}`"
                          tabindex="0"
                          class="d-flex flex-column justify-content-stretch"
                          v-else-if=" item.type === JOB_QUESTION_TYPES.GENDER || item.type === JOB_QUESTION_TYPES.VISA_STATUS || item.type === JOB_QUESTION_TYPES.ETHNICITY || item.type === JOB_QUESTION_TYPES.BOARD_CERTIFICATION"
                        >
                        <b-button
                            variant="v3_teal_outline text-break"
                            :class="[
                              'mb-2',
                              'position-relative',
                              {
                                active: selectedJobQuestionId === item.id,
                              },
                            ]"
                            :disabled="isDisabled || !isChangeJobCriteriaEnable"
                            @click="onChangeCriteria(item)"
                          >
                            {{ getLabel(item) }}
                            <i class="mdi mdi-lock" aria-hidden="true" v-if="isDisabled" />
                          </b-button>
                          
                        </div>
                        <b-tooltip
                          v-if=" item.type !== JOB_QUESTION_TYPES.GENDER && item.type !== JOB_QUESTION_TYPES.VISA_STATUS && item.type !== JOB_QUESTION_TYPES.ETHNICITY && item.type !== JOB_QUESTION_TYPES.BOARD_CERTIFICATION"
                          :key="`criteria-tooltip-${item.id}`"
                          :target="`criteria-btn-${item.id}`"
                          triggers="hover"
                        >
                            Specialty, Location, Practice Type, and Compensation of your opportunity are required to see the yield of matching candidates.
                        </b-tooltip>
                        <b-tooltip
                          v-else
                          :key="`criteria-tooltip-${item.id}`"
                          :target="`criteria-btn-${item.id}`"
                          triggers="hover"
                        >
                            These additional Job Criteria filters are available after you connect this opportunity.
                        </b-tooltip>
                      </template>
                    </div>
                  </template>
                </recruiter-ico-criteria> -->
              </b-col>
              <b-col sm="12" md="8" lg="6" class="position-relative mb-5" ref="step2" id="step2">
                <div class="text-center mt-2 mb-1" v-if="!this.jobInfoText || this.isShowStep == 6">
                    <b class="v3_color_teal">Step 2. Define Job Criteria</b>
                </div>
                <div class="border_1 border_light_teal h-100 w-100 p-3">
                  <template v-if="selectedJobQuestion  && this.isShowStep==1">
                    <div class="h-100">
                      <recruiter-ico-criteria-detail   
                        :key="selectedJobQuestion.id"                   
                        :job-question="selectedJobQuestion"
                        :job-offer="jobOffer"
                        :criteria-items="criteriaItems"
                        :criteriaJobQuestions="criteriaJobQuestions"
                        :loading-detail="loadingDetail"
                        @set-criteria-value="onSetCriteriaValue"
                        @update-criteria-value="onUpdateCriteriaValue"
                        @clear-criteria-value="onClearCriteria"
                        @set-terms-value="onSetTermValue"
                        :filter-user-count="true"
                        @isJobInfoActive="showJobInfo"
                        @save-details="updateJobOfferDetails"
                        :isOtherCriteriaDisabled="this.isDisabled"
                        :practiceTypeFlag="this.practiceTypeFlag"
                        :maxCompFlag="this.maxCompFlag"
                        :job_opportunity_duration="this.job_opportunity_duration"
                        :job_opportunity_price="this.job_opportunity_price"
                        @show-connect-opp-btn="onConnectOpportunity"
                        :job-builder-landing-content="this.landingContent"
                      />
                    </div>
                    <!-- <template v-else>
                    <div class="d-flex align-items-center mt-4 w-100">
                      <div
                        class="text-center v3_color_teal d-flex flex-column justify-content-center w-100"
                      >
                        <div v-html="this.landingContent ? this.landingContent[0].content_json.body : ''"></div>
                      </div>
                    </div>
                  </template> -->
                    <!-- <template v-else>
                      <div class="d-flex align-items-center mt-4 w-100">
                        <div
                          class="text-center v3_color_teal d-flex flex-column justify-content-center w-100"
                        >
                          <div v-html="this.landingContent ? this.landingContent[0].content_json.body : ''"></div>
                        </div>
                      </div>
                    </template> -->
                    <!-- <b-form-row v-if="!isShowNextBtn &&  selectedJobQuestion">
                      <b-col cols="5" class="d-flex justify-content-right mt-3"></b-col>
                        <b-col cols="7"  class="d-flex justify-content-left mt-3">
                          <b-button
                          variant="primary"
                          type="submit"
                          class="px-5 btn-disable-btn position-bottom"
                          @click="handleButtonClick()"
                          :disabled="isNextDisabled"
                          >
                          <span>Next</span> <i class="mdi mdi-arrow-right-bold ml-1"></i>
                        </b-button>
                      </b-col>
                    </b-form-row> -->
                  </template>
                  <!-- <template v-else-if="this.isShowStep==2">
                      <recruiter-user-info
                          :loading="loadingDetail"   
                          :isShowStep="isShowStep"  
                          @updatePropValue="updateIsShowStep"             
                      />
                  </template> -->
                  <template v-else-if="this.isShowStep==3">
                  <review-job-offer
                      :loading="loadingDetail"   
                      :isShowStep="isShowStep"  
                      @updatePropValue="updateIsShowStep"  
                  />
                  </template>
                  <template v-else-if="this.isShowStep == 4">
                    <purchase-selection
                        :loading="loadingDetail"   
                        @payment-method="paymentMethod"
                    />
                  </template>
                  <template v-else-if="this.isShowStep == 9">
                    <job-offer-invoice-form
                        :loading="loadingDetail"   
                        :isShowStep="isShowStep"  
                        @payment-method="paymentMethod"
                    />
                  </template>
                  <template v-else-if="this.isShowStep == 7">
                  <purchase-page
                      :loading="loadingDetail"   
                      :isShowStep="isShowStep"  
                      @updatePropValue="updateIsShowStep"  
                  />
                  </template>
                  <template v-else-if="this.isShowStep == 5">
                  <b-row class="center-align-box">
                      <b-col cols="6" class="text-center">
                      <b-button class="post_opportunity_btn" variant="v2_primary pt-5 pb-6" @click="saveJobOffer('dashboard')">
                          <p class="font_weight_semibold v2_font_size_20">Go To Dashboard</p>
                          <p>Monitor and Manage candidates for your Job Opportunity</p>
                      </b-button>
                      </b-col>

                      <b-col cols="6" class="text-center">
                      <b-button class="post_opportunity_btn" variant="v2_primary pt-5 pb-6" @click="saveJobOffer('inform')">
                          <p class="font_weight_semibold v2_font_size_20">Go to Inform</p>
                          <p>Assess specialty benchmarking data to refine your Job Opportunity</p>
                      </b-button>
                      </b-col>
                  </b-row>
                  </template>
                  <template v-else-if="this.isShowStep==6">
                    <div class="d-flex align-items-center mt-4 w-100">
                      <div
                        class="text-center v3_color_teal d-flex flex-column justify-content-center w-100"
                      >
                        <template>
                          <div class="h-100">
                            <div class="d-flex justify-content-center position-bottom mini-screen-criteria-btn-main-div">
                              <b-button class="px-5 btn-disable-btn justify-content-center mr-1 mini-mt-2 justify-content-center"  @click="onConnectOpportunity">
                                Connect Your Opportunity
                              </b-button>
                            </div>
                          </div>
                        </template>
                        <!-- <span>
                          Please select a criteria on the left to modify for the Job Opportunity
                        </span><p /> -->
                        
                        
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="d-flex align-items-center mt-4 w-100">
                      <div
                        class="text-center v3_color_teal d-flex flex-column justify-content-center w-100"
                      >
                        <span>
                          1. Select and define required Job Criteria to build your job.
                        </span><p />
                        <span>
                          2. Assess “Number of Matches” to see the number of candidates interested in your opportunity.
                        </span><p />
                        <span>
                          3. Click “Connect Your Opportunity” to inform matching candidates their dream job awaits.
                        </span><p />
                      </div>
                    </div>
                  </template>
                </div>
              </b-col>
              <b-col sm="12" md="12" lg="3" class="mt-md-2 mt-lg-0 mb-5" ref="step3" id="step3">
                <div class="text-center mt-2 mb-1" v-if="!this.jobInfoText || this.isShowStep == 6">
                  <b class="v3_color_teal">Step 3. Evaluate Results</b>
                </div>
                <div
                  class="border_1 border_light_teal h-100 w-100 pt-1 pb-4 p-3 px-3"
                >
                  <b-row>
                    <b-col sm="12" md="6" lg="12">
                      <recruiter-ico-criteria-results
                        :criteria-items="criteriaItems"
                        :isChangeJobCriteriaEnable="this.isChangeJobCriteriaEnable"
                        :isShowStep="this.isShowStep"
                      />
                    </b-col>
                    <b-col sm="12" md="6" lg="12" class="mt-3 mt-md-0 mt-lg-3 matches-box-bottom">
                      <div
                        class="border_1 border_light_teal h-100 w-100 pt-1 pb-1 px-2 mt-3"
                      >
                        <recruiter-ico-matching
                          :value="matchingValue"
                          :loading="loadingMatching"
                        />
                        <div class="mt-3 d-flex justify-content-center">
                          <!-- <b-button
                            v-if="jobOffer"
                            variant="v3_teal_outline"
                            @click="onAfterPaidContinue"
                          >
                            Continue
                          </b-button> -->
                          <!-- <b-button
                            v-else
                            variant="v3_teal_outline"
                            @click="showPurchaseModal"
                          >
                            Purchase Connect
                          </b-button> -->
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <!-- <p class="font_size_1125rem font-weight-bold v3_color_teal mt-4">
              Let candidates know their ideal job is waiting for them.
            </p> -->
            <template v-if="!this.jobInfoText">
              <!-- <b-button class="mt-4 btn-disable-btn" v-if="user" variant="primary" :disabled="!isEnableOpportunityBtn" @click="confirmCustomePofile()">
                Connect Your Job Opportunity
              </b-button> -->
              <!-- <b-button class="mt-5 btn-disable-btn" v-if="!user" variant="primary" :disabled="!isEnableOpportunityBtn"  @click="showComingSoonModal()" @continue="onContinue">
                Connect Your Opportunity
              </b-button> -->
            </template>

          </div>
          <coming-soon-modal
            v-if="comingSoonModalVisible"
            :visible="comingSoonModalVisible"
            :job_opportunity_price="this.job_opportunity_price"
            :job_opportunity_duration="this.job_opportunity_duration"
            @modal-close="comingSoonModalVisible = false"
        />
        </b-card-body>
      </b-card>
    </div>
    <purchase-modal
      v-if="isPurchaseModalVisible"
      v-model="isPurchaseModalVisible"
      @cancel="isPurchaseModalVisible = false"
      @job-offer-paid="onJobOfferPaid"
    />
  </div>
</template>

<script>
import Api from '@/providers/Api';
import RecruiterIcoCriteria from '@/components/recruiter/ico/criteria/RecruiterIcoCriteria';
import RecruiterIcoMatching from '@/components/recruiter/ico/matching/RecruiterIcoMatching';
import RecruiterIcoCriteriaDetail from '@/components/recruiter/ico/criteria/RecruiterIcoCriteriaDetail';
import RecruiterIcoCriteriaResults from '@/components/recruiter/ico/criteria/RecruiterIcoCriteriaResults';
import PurchaseModal from '@/components/recruiter/payment/PurchaseModal';
import { createAdditionalCriteriaItems } from '@/helpers/recruiter/IcoBrowser/criteriaHelper';
import {
  JOB_OTHER_CRITERIA,
  JOB_TERMS,
  JobInformationCriteria
} from '@/helpers/recruiter/jobOfferHelper';
import { COOKIES, JOB_QUESTION_TYPES } from '@/store';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import ComingSoonModal from '@/components/pre-paywall-pages/recruiter/ComingSoonModal';
import ReviewJobOffer from '@/components/recruiter/exchange/review/ReviewJobOffer';
import PurchasePage from '@/components/recruiter/payment/PurchasePage.vue';
import PurchaseSelection from '@/components/recruiter/payment/PurchaseSelection.vue';
import JobOfferInvoiceForm from '@/components/recruiter/payment/JobOfferInvoiceForm.vue';
import { isMobile } from '@/utils/isMobile';

export default {
  name: 'IcoBrowserNew',
  components: {
    RecruiterIcoCriteriaDetail,
    RecruiterIcoMatching,
    RecruiterIcoCriteria,
    RecruiterIcoCriteriaResults,
    PurchaseModal,
    ComingSoonModal,
    ReviewJobOffer,
    PurchasePage,
    PurchaseSelection,
    JobOfferInvoiceForm
  },
  data: function () {
    return {
      criteriaItems: [],
      selectedJobQuestion: null,
      loadingDetail: false,
      matchingValue: '-',
      loadingMatching: false,
      isPurchaseModalVisible: false,
      jobOffer: {},
      comingSoonModalVisible: false,
      isDisabled: true,
      isShowNextBtn:false,
      LocationDisabled:!this.$store.state.user ? false : true,
      LocationLocked: false,
      practiceTypeFlag:!this.$store.state.user ? false : true,
      maxCompFlag:!this.$store.state.user ? false : true,
      isNextDisabled:true,
      job_opportunity_price:'0',
      job_opportunity_duration:'0',
      isShowStep:0,
      jobInfoText:false,
      isSpecialtyDisabled:false,
      isSpecialtyLocked: false,
      isChangeJobCriteriaEnable:true,
      isGenderDisabled:true,
      isEthnicityDisabled:true,
      isBoardDisabled:true,
      isVisaDisabled:true,
      showJobTermText:false,
      showJobLandingContent:false,
      landingContent:null,
      activeIndices: [0],
      criteriaJobQuestions: []
    };
  },
  created: function () {
    this.getData();

    // Show the instructional content show by default on ICO Browser until recruiter clicks specialty
    if(!this.$store.state.user)
    {  
      this.isShowStep=0;
    }else if(this.$store.state.is_come_from_registration){
      this.isShowStep=6;
    }else{      
      this.isShowStep=8;
    }
  
    if(this.$store.state.job_offer)
    {
      this.isSpecialtyDisabled = true;
      this.isSpecialtyLocked = true;
      this.LocationDisabled = true;
      this.LocationLocked = true;
      this.practiceTypeFlag = true;
      this.maxCompFlag = true;
      this.isSpecialtyDisabled = true;
      if(this.$store.state.is_come_from_registration){
        this.isChangeJobCriteriaEnable = true;
        this.isSpecialtyDisabled = false;
        this.isSpecialtyLocked=true;
        this.LocationDisabled = false;
        this.LocationLocked = true;
        this.practiceTypeFlag = false;
        this.maxCompFlag = false;
        this.isDisabled = false;
        this.isGenderDisabled = false;
        this.isEthnicityDisabled = false;
        this.isBoardDisabled=false;
        this.isVisaDisabled=false;
      }else{
        this.isChangeJobCriteriaEnable=false;
      }
      this.selectedJobQuestion = this.$store.state.job_offer[0];
    }
  },
  mounted: function () {
    if (this.$cookies.isKey(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)) {
      this.isPurchaseModalVisible = true;
    }
  },
  computed: {
    user: function () {
      return this.$store.state.user ? this.$store.state.user : null;
    },
    isSpecialtySubspecialtySpecified: function () {
      const specialtyCriteria = this.criteriaItems.find(
        (item) => item.type === JOB_QUESTION_TYPES.SPECIALTY && item.type !== JOB_QUESTION_TYPES.GENDER
      );

      return (
        specialtyCriteria &&
        specialtyCriteria.value &&
        specialtyCriteria.value.subspecialtyId
      );
      
    },
    isEnableOpportunityBtn: function () {
     
      const specialtyCriteria = this.criteriaItems.find(
        (item) => item.type === JOB_QUESTION_TYPES.SPECIALTY
      );

      const locationCriteria = this.criteriaItems.find(
        (item) => item.type === JOB_QUESTION_TYPES.LOCATION
      );

      const practiceTypeCriteria = this.criteriaItems.find(
        (item) => item.type === JOB_QUESTION_TYPES.SELECT_ANY
      );

      const maxTotalCompansation = this.criteriaItems.find(
        (item) => item.type === JOB_QUESTION_TYPES.SLIDER
      );

      return (
        (specialtyCriteria &&
        specialtyCriteria.value &&
        specialtyCriteria.value.subspecialtyId) &&
        (locationCriteria &&
        locationCriteria.value &&
        locationCriteria.value.location_zip_code) &&
        (practiceTypeCriteria &&
        practiceTypeCriteria.value) &&
        (maxTotalCompansation &&
        maxTotalCompansation.value)
      );
    },
    JOB_QUESTION_TYPES: function () {
      return JOB_QUESTION_TYPES;
    },
    selectedJobQuestionId: function () {
      return this.selectedJobQuestion ? this.selectedJobQuestion.id : null;
    },
    icoMainDiv:function()
    {
      return {
        'recruiter ico-browser font_Montserrat v3_color_black_knight px-3': true,
        'mt-0': this.user,
      };
    }
  },
  methods: {
    getData: async function () {
      const additionalCriteria = createAdditionalCriteriaItems();
      //const jobQuestions = await Api.getJobQuestionsForIcoBrowser();
      //const jobQuestions = (this.$store.state.user) ? await Api.getJobQuestionsForJobOffer() : await Api.getJobQuestionsForGuestIcoBrowser();
      const jobQuestions = await Api.getJobQuestionsForGuestIcoBrowser();
      
      if(this.$store.state.job_offer)
      {
          this.criteriaItems = this.$store.state.job_offer;
          if(this.$store.state.user)
          {
            const jIndex = this.$store.state.job_offer.findIndex((jt) => jt.type === "JOB_INFORMATION");
            this.selectedJobQuestion = this.criteriaItems[jIndex];      
          }
      }else{
        const filteredJobOtherCriteria = JOB_OTHER_CRITERIA.filter(criteria => {
          const updatedCriteria = { ...criteria }; 
          if (Array.isArray(updatedCriteria.jobQuestionVariables)) {    
            const indexToRemove = updatedCriteria.jobQuestionVariables.findIndex(item => item.id === "PNA" || item.id === "NA");
            if (indexToRemove !== -1) {
              updatedCriteria.jobQuestionVariables.splice(indexToRemove, 1);
            }
          }  
          return updatedCriteria;
        });
        this.criteriaItems = [...additionalCriteria, ...jobQuestions,...filteredJobOtherCriteria,...JOB_TERMS,...JobInformationCriteria];
        this.criteriaJobQuestions = jobQuestions;

          this.criteriaItems.forEach((jt) => {
            if (jt.type === 'GENDER' || jt.type === 'BOARD_CERTIFICATION' || jt.type === 'VISA_STATUS' || jt.type === 'ETHNICITY') {
              jt.value=null;
            }
          });
          this.selectedJobQuestion = this.criteriaItems[0];
      }
      
      if (this.$cookies.isKey(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)) {
        const values = JSON.parse(
          this.$cookies.get(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)
        );
        values.forEach(({ id, type, value }) => {
          if (!value) return;
          const index = this.criteriaItems.findIndex((i) => {
            return (
              i.id === id ||
              (i.type === JOB_QUESTION_TYPES.SPECIALTY &&
                type === JOB_QUESTION_TYPES.SPECIALTY) ||
              (i.type === JOB_QUESTION_TYPES.LOCATION &&
                type === JOB_QUESTION_TYPES.LOCATION)
            );
          });
          if (index === -1) return;
          this.$set(this.criteriaItems[index], 'value', { ...value });
        });
        this.updateMatching();
      }

      this.updateMatching();

      const jobOpportunityPrice = await Api.getSettingByKey('job_opportunity_price');
      this.job_opportunity_price = jobOpportunityPrice.value;

      const jobOpportunityDuration = await Api.getSettingByKey('job_opportunity_duration');
      this.job_opportunity_duration = jobOpportunityDuration.value;
      
    },
    onSetCriteriaValue: function (params) {
      //alert(JSON.stringify(params));
      const index = this.criteriaItems.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      this.$set(this.criteriaItems[index], 'value', { ...params });
      
      if(params.location_zip_code)
      {
        this.$store.state.location_zip_code = params.location_zip_code;
        this.LocationDisabled= false;
        this.LocationLocked = this.$store.state.user ? true : false;
      }else if(index==2)
      {
        this.practiceTypeFlag=false;
      }else if(index==3)
      {
        this.maxCompFlag=false;
        if(this.$store.state.user)
        {
          this.isGenderDisabled=false;
          this.isEthnicityDisabled=false;
          this.isBoardDisabled=false;
          this.isVisaDisabled=false;
        }
      }

      // ///// disable specialty ////
      if(params.specialtyId)
      {
        //this.isSpecialtyDisabled=true;
        this.$store.state.is_new_offer = 1;
        this.$store.state.specialtyId = params.specialtyId;
        this.isSpecialtyDisabled=false;
        this.isSpecialtyLocked=this.$store.state.user ? true : false;
      }

      this.$nextTick(() => {
        this.updateMatching();
        if(index < this.findSecondLastIndex())
        {
          if (!this.activeIndices.includes(index + 1)) {
            this.activeIndices.push(index + 1);
          }
          if (!isMobile()) {
            this.handleButtonClick(params.nextStep, index);
          }
        }else{
          
          const maxIndex = Math.max(...this.activeIndices);
          const numMissingIndices = this.criteriaItems.length - this.activeIndices.length;
    
          const missingIndices = Array.from({ length: numMissingIndices }, (_, index) => index + maxIndex + 1);
          this.activeIndices = [...this.activeIndices, ...missingIndices];
        }

        /* Mobile Vesrion Only 
          Step 3 : Evaluate Result
        */
        if (isMobile()) {
          this.scrollTo('step3');
        }
      });
    
      this.isNextDisabled = false;
      this.$store.state.isComeFromIco = true;
    },
    onUpdateCriteriaValue: function (params) {
      const index = this.criteriaItems.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      this.$set(this.criteriaItems[index], 'value', { ...params });
      
      // ///// disable specialty ////
      if(params.specialtyId)
      {
        //this.isSpecialtyDisabled=true;
        this.$store.state.is_new_offer = 1;
        this.$store.state.specialtyId = params.specialtyId;
        this.isSpecialtyDisabled=false;
        this.isSpecialtyLocked=this.$store.state.user ? true : false;
      }
      this.$nextTick(() => {
        this.updateMatching();
      });
    
      this.isNextDisabled = false;
      
      /* Mobile Vesrion Only 
        Step 3 : Evaluate Result
      */
      if (isMobile()) {
        this.scrollTo('step3');
      }
    },
    onSetTermValue: function (params) {    
      const index = this.criteriaItems.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      if(JOB_QUESTION_TYPES.ETHNICITY && index == 5){
        this.$set( this.criteriaItems[index], 'value', params ? params : {} );        
      }else{
        let key = Object.keys(params)[0];        
        this.$set(this.criteriaItems[index], 'value', key ? { 0: key,} : {});
      }
      // this.$nextTick(() => {
      //   this.updateMatching();
      // });
      this.updateMatching();
      
      if(index==4)
      {
        this.isGenderDisabled=false;
      }else if(index==5)
      {
        this.isEthnicityDisabled=false;
      }else if(index==6){
        this.isBoardDisabled=false;
       
      }else if(index==7){
        this.isVisaDisabled=false;
      }
      
      // if(index < 7)
      // {
      //   this.selectedJobQuestion = this.criteriaItems[index+1];
      // }

      this.isNextDisabled = false;
      this.$store.state.isComeFromIco = true;
    },
    onClearCriteria: function () {
      const index = this.criteriaItems.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      this.$set(this.criteriaItems[index], 'value', null);

      this.$nextTick(() => {
        this.updateMatching();
      });
    },
    onChangeCriteria: async function (jobQuestion) {
      const jqIndex = this.criteriaItems.findIndex(
        (jq) => jq.id === jobQuestion.id
      );
      let jqLength =  this.filterJobQuestionData().length + 2;

      if(jqIndex >= jqLength)
      {
        this.showJobTermText = true;
      }else{
        this.showJobTermText = false;
      }
     
      if(!this.$store.state.user)
      {
        this.isShowStep = 1;
      }else{
        // if(jqIndex==0 )
        // {
          
        // }
        this.updateIsShowStep(1);
      }
      this.showJobLandingContent = false;
      this.landingContent=null;
      this.$store.state.ico_not_authenticated_user = undefined;
      this.selectedJobQuestion = this.criteriaItems[jqIndex];

      /* Mobile Vesrion Only 
        Step 2 : Define Job Criteria
      */
      if (isMobile()) {
        this.scrollTo('step2');
        /* stopped overlap tooltip on mobile version */
        this.checkMobileTooltipClass();
      }
    },
    filterJobQuestionData() {
      return this.criteriaItems.filter(obj => obj.hasOwnProperty("firstVariable"));
    },
    updateMatching: async function () {
      this.loadingMatching = true;
      try {
        this.matchingValue = (this.$store.state.user) ? await Api.findNumberOfMatches(this.criteriaItems,0) : await Api.findNumberOfMatchesOnGuestIcoBrowser(this.criteriaItems);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loadingMatching = false;
      }
    },
    showPurchaseModal: function () {
      this.isPurchaseModalVisible = true;
    },
    onJobOfferPaid: function (jobOffer) {
      this.isPurchaseModalVisible = false;
      this.jobOffer = jobOffer;
    },
    onAfterPaidContinue: function () {
      this.$router.push(`/recruiter/edit-job-offer/${this.jobOffer.id}`);
    },
    // confirmCustomePofile: function () {
    //   this.$store.state.job_offer = this.criteriaItems;
    //   this.$store.state.set_job_information = true;
    //   const index = this.criteriaItems.findIndex((jt) => jt.type === "JOB_INFORMATION");
    //   if (index === -1)  this.selectedJobQuestion = this.criteriaItems[index]; else  this.selectedJobQuestion = this.criteriaItems[index];
    //   this.isChangeJobCriteriaEnable = false;
    //   this.isDisabled = true;
    //   this.isGenderDisabled = true;
    //   this.isEthnicityDisabled = true;
    //   this.isBoardDisabled=true;
    //   this.isVisaDisabled=true;
    //   this.isSpecialtyDisabled = true;
    //   this.LocationDisabled = true;
    //   this.LocationLocked = true;
    //   this.practiceTypeFlag = true;
    //   this.maxCompFlag = true;
    //   this.isSpecialtyLocked=true;
    //   //this.$store.state.is_change_criteria=1;
    //   //this.$router.push(`/recruiter/job-summary`);
    // },
    showComingSoonModal: function () {
      localStorage.setItem('job_offer_signup_data', JSON.stringify(this.criteriaItems));
      this.$store.state.job_offer = this.criteriaItems;
      this.$store.state.set_job_information = true;
      this.comingSoonModalVisible = true;
      this.isDisabled = true;
      this.isGenderDisabled = true;
      this.isBoardDisabled=true;
      this.isVisaDisabled=true;
      this.isEthnicityDisabled = true;
    },
    onContinue: function () {
      this.$router.push('/recruiter/sign-up');
    },
    handleButtonClick(nextStep, index) {
      if(nextStep === 'LOCATION'){
        this.LocationDisabled = false;
        this.LocationLocked = false;
        // this.selectedJobQuestion = this.criteriaItems[1];
        this.isShowNextBtn=true;
      }else if(nextStep === 'PRTYPE')
      {
        this.practiceTypeFlag = false;
        // this.selectedJobQuestion = this.criteriaItems[2];
        this.isShowNextBtn=true;
      }else 
      {
          this.maxCompFlag = false;
          // this.selectedJobQuestion = this.criteriaItems[3];
          this.isShowNextBtn=false;
      }
      this.selectedJobQuestion = this.criteriaItems[index + 1];
    },
    updateJobOfferDetails: function (data) {
    const {
      title,
      description,
      tracking,
      jobBoardUrl,
      company,
      welcome_message,
      practice_name,
    } = data;
    this.$set(this.jobOffer, 'title', title);
    this.$set(this.jobOffer, 'description', description);
    this.$set(this.jobOffer, 'tracking_num', tracking);
    this.$set(this.jobOffer, 'external_url', jobBoardUrl);
    this.$set(this.jobOffer, 'company_name', company);
    this.$set(this.jobOffer, 'welcome_message', welcome_message);
    this.$set(this.jobOffer, 'practice_name', practice_name);
    this.isJobOfferDirty = true;
    this.isShowStep = 3; ///  For set Customer User Information update it 2.

    //this.isChangeJobCriteriaEnable=true;

    this.$store.state.job_information =  {
      ...this.$store.state.job_information,
      title: title,
      description: description,
      tracking_num: tracking,
      external_url: jobBoardUrl,
      company_name: company,
      welcome_message: welcome_message,
      practice_name: practice_name,
    };
    },
    updateIsShowStep(newValue) {
     this.isShowStep = newValue;
    },
    paymentMethod(newValue) {
      if(newValue=='invoice'){
        this.isShowStep = 9;
      }else{
        this.isShowStep = 7;
      }
    },
    showJobInfo: function(data){
     this.jobInfoText=data;
    },
    showLockIconOnQuestion: function (item) {
      if(this.$store.state.is_change_criteria)
      {
        return false;
      }
      if(item.talent_type == 'LOCATION')
      {
        if(this.$store.state.location_zip_code)
        {
          return true;
        }else{
          return false;
        }
      }else{
        return (
          !!item.value 
        );
      }
    },
    async handlechangeCriteriaBtn(){
      this.isSpecialtyLocked=true;
      this.LocationLocked = true;
      this.LocationDisabled = false;
      this.isSpecialtyDisabled = false;
      // this.practiceTypeFlag = false;
      // this.maxCompFlag = false;
      //this.isDisabled = false;
      // this.isGenderDisabled = false;
      // this.isEthnicityDisabled = false;
      // this.isBoardDisabled=false;
      // this.isVisaDisabled=false;
      this.isChangeJobCriteriaEnable = true;
      /*
      Get JOb Builder Landing Page Content
      */
      if(this.$store.state.ico_not_authenticated_user){
        this.landingContent =  await Api.getJobBuilderLanding();
        if(this.landingContent != null)
        {
          this.showJobLandingContent=true;
        }
      }
     
      //this.isShowStep=6;
      this.$store.state.job_offer = this.criteriaItems;
      this.$store.state.set_job_information = false;
      this.isShowStep=6;
      // this.selectedJobQuestion = this.$store.state.ico_not_authenticated_user ? this.criteriaItems[4] : this.criteriaItems[0];
    },
    onConnectOpportunity : function () {
      this.$store.state.job_offer = this.criteriaItems;
      this.$store.state.set_job_information = true;
      const index = this.criteriaItems.findIndex((jt) => jt.type === "JOB_INFORMATION");
      if (index === -1)  this.selectedJobQuestion = this.criteriaItems[index]; else  this.selectedJobQuestion = this.criteriaItems[index];
      this.isChangeJobCriteriaEnable = false;
      this.isDisabled = true;
      this.isGenderDisabled = true;
      this.isEthnicityDisabled = true;
      this.isBoardDisabled=true;
      this.isVisaDisabled=true;
      this.isSpecialtyDisabled = true;
      this.LocationDisabled = true;
      this.LocationLocked = true;
      this.practiceTypeFlag = true;
      this.maxCompFlag = true;
      this.isSpecialtyLocked=true;
      this.isShowStep=1;
    },
    findSecondLastIndex() {
      let secondLastIndex = -1;
      let count = 0;
      // Iterate the array in reverse order
      for (let i = this.criteriaItems.length - 1; i >= 0; i--) {
        const obj = this.criteriaItems[i];
        // Check if the object contains the 'firstVariable' key
        if (obj.firstVariable !== undefined) {
          count++;
          // Check if this is the second last object with 'firstVariable' key
          if (count === count) {
            secondLastIndex = i;
            break;
          }
        }
      }
      return secondLastIndex;
    },
    isLabelDisable : function(index) {
      if(this.$store.state.user){
        if(this.isChangeJobCriteriaEnable){
          if(this.$store.state.is_come_from_registration){
            return false;
          }else{
            return !this.activeIndices.includes(index);
          }
          //return false;
        }else{
          return true;
        }
      }else{
        if(index <= this.findSecondLastIndex()){
          return false;
        }else{
          return true;
        }
      }
    },
    displayLock : function (index){
      if(this.$store.state.user){
        // if(!this.isChangeJobCriteriaEnable){
        //   console.log(this.isChangeJobCriteriaEnable, "34243");
        //   return true;
        // }

        if(this.isChangeJobCriteriaEnable){
          if(this.activeIndices.length == 1){
            if(this.$store.state.is_come_from_registration){
              if(index > 1){
                return false;
              }else {
                return true;
              }
            }else{
              if(index > 1){
                return true;
              }else {
                return false;
              }
            }
              
          }else if (this.activeIndices.length == 2){
          
            if(index == 0){
              return true;
            }else if(!this.activeIndices.includes(index)){
              return true;
            }else{
              return false;
            }
          }
          else if (this.activeIndices.length > 2){
            if(index == 0){
              return true;
            }else if(index == 1){
              return true;
            }else if(!this.activeIndices.includes(index)){
              return true;
            }else{
              return false;
            }
          }
        }else{
          return true;
        }
        
      }else{
        if(index <= this.findSecondLastIndex()){
          return false;
        }else{
          return true;
        }
      }
    },
    scrollTo(refName) {
      const target = this.$refs[refName];
      if (target) {
        
        let headerOffset = 490;
        let menuHeaderHeight = 200;

        if(refName == 'step3'){
          const step1Element = this.$refs.step1;
          if (step1Element) {
            headerOffset = step1Element.offsetHeight + menuHeaderHeight; // or use element.getBoundingClientRect().height
          }
          const step2Element = this.$refs.step2;
          if (step2Element) {
            headerOffset = headerOffset + step2Element.offsetHeight; // or use element.getBoundingClientRect().height
          }
          headerOffset = step1Element.offsetHeight + step2Element.offsetHeight + menuHeaderHeight;
        }else{
          const step1Element = this.$refs.step1;
          if (step1Element) {
            headerOffset = step1Element.offsetHeight + menuHeaderHeight; // or use element.getBoundingClientRect().height
          }
        }
        // const elementPosition = target.getBoundingClientRect().top + window.scrollY;
        // const offsetPosition = elementPosition - headerOffset;
        window.scrollTo({
          top: headerOffset,
          behavior: 'smooth'
        });
      }
    },
    checkMobileTooltipClass() {
      const element = document.querySelector('.tooltip.fade.show.bs-tooltip-top');
      if (element) {
        element.style.zIndex = '9';
      } 
    }
    // getJobBuilderLandingContent:async function() {
    //   try {
    //     await Api.getJobBuilderLanding();
    //   } catch {
    //   }
    // }
  },
};
</script>

<style scoped>
@media only screen and (min-width: 320px) and (max-width:768px){
  .box-body-wrapper{
    padding: 1rem;
    justify-content: center;
  }
}
@media (max-width:1500px){
    .matches-box-bottom{
      max-width: 90% !important;
      bottom:10px !important;
    }
}
@media (max-width:1300px){
    .matches-box-bottom{
      max-width: 89% !important;
      bottom:10px !important;
    }
}
@media (max-width:768px){
  .mb-5{
    margin-bottom:50px !important;
  }
  .matches-box-bottom{
    position: unset !important;
    max-width: 100% !important;
  }
}
@media (max-width:767px){
  .position-bottom{
    position:unset !important;
  }
}
.mb-5{
  margin-bottom:0px;
}
</style>

<style lang="scss" scoped>
@import '../../../../sass/variables_mixins.scss';

.recruiter {
  font-family: $phairify_font_montserrat;
}
.position-relative{
  position: relative;
}
.position-relative i{
  position: absolute;
  right: 10px;
}
.btn-disable-btn{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #b0d27b !important;
  border: 1px solid #00586f !important;
  border-color: #00586f !important;
  opacity: 1;
}
.btn-disable-btn:disabled{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #dee9ec !important;
  border: 1px solid #00586f !important;
  border-color: #00586f !important;
  opacity: 1;
}
.btn-disable-btn i{
  font-size: 15px;
}
.btn.btn-primary.disabled{
  border-color: #00586f !important;
}
btn-next{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #b0d27b !important;
  border: 1px solid #00586f !important;
  opacity: 1;
  border-radius: 20px;
}
.btn-next i{
  font-size:15px;
}
.position-relative{
  position: relative;
}
.position-bottom{
  position:absolute;bottom: 20px;
}
.matches-box-bottom{
  position: absolute;
  bottom: 10px;
  max-width: 92%;
  margin: 0 auto !important;
  width: 100%;
  left: 10px;
  right: 10px;
}
.mt-15{
  margin-top:15px !important;
}
.mt-0{
  margin-top:0px !important;
}
.m-0-auto{
  margin: 0 auto;
}
.tooltip {
  z-index: 9 !important;
}
@media (max-width:1300px){
  .mini-screen-criteria-btn-main-div{
    flex-flow: column;
    width: 70%;
    margin: 0 auto;
  }
  .mini-mt-2{
    margin-top: 1.5rem;
  }
}
</style>
